/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MatterState = "CLOSED" | "DRAFT" | "OPEN" | "%future added value";
export type MatterRouteQueryVariables = {
    matterId: string;
    tenantId: string;
};
export type MatterRouteQueryResponse = {
    readonly matter: {
        readonly id: string;
        readonly creator?: {
            readonly id: string;
            readonly name: string;
        } | null;
        readonly number?: number;
        readonly insertedAt?: string;
        readonly title?: string;
        readonly dueDate?: string | null;
        readonly state?: MatterState;
        readonly status?: {
            readonly name: string;
            readonly textColor: string;
            readonly color: string;
        };
        readonly assignees?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly actor: {
                        readonly id: string;
                        readonly name?: string;
                    };
                } | null;
            } | null> | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"FlowList_flows" | "MatterTimeline_timeline">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"MatterTimeline_threads">;
};
export type MatterRouteQuery = {
    readonly response: MatterRouteQueryResponse;
    readonly variables: MatterRouteQueryVariables;
};



/*
query MatterRouteQuery(
  $matterId: ID!
  $tenantId: ID!
) {
  matter: node(id: $matterId) {
    __typename
    id
    ... on Matter {
      ...FlowList_flows_2ON54F
      ...MatterTimeline_timeline_2ON54F
      creator {
        id
        name
      }
      number
      insertedAt
      title
      dueDate
      state
      ... on HasStatus {
        __isHasStatus: __typename
        status {
          name
          textColor
          color
          id
        }
      }
      assignees {
        edges {
          node {
            id
            actor {
              __typename
              id
              ... on User {
                name
              }
              ... on Group {
                name
              }
            }
          }
        }
      }
    }
  }
  ...MatterTimeline_threads_1NrG5d
}

fragment FlowList_flows_2ON54F on HasFlows {
  __isHasFlows: __typename
  flows(first: 100) {
    edges {
      cursor
      node {
        id
        title
        fields(types: ["de.netzwerkpartner.hotline.request"]) {
          __typename
          ... on DeNetzwerkpartnerHotlineRequest {
            descriptionText
            ... on HasFiles {
              __isHasFiles: __typename
              files {
                edges {
                  node {
                    id
                    contentLength
                    name
                  }
                }
              }
            }
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ... on Node {
    __isNode: __typename
    id
  }
}

fragment MatterTimeline_threads_1NrG5d on RootQueryType {
  threads(refId: $matterId, tenantId: $tenantId) {
    edges {
      node {
        id
        messages {
          edges {
            node {
              creator {
                name
                id
              }
              id
              bodyText
              insertedAt
            }
          }
        }
      }
    }
  }
}

fragment MatterTimeline_timeline_2ON54F on HasTimeline {
  __isHasTimeline: __typename
  timeline(first: 100) {
    edges {
      node {
        __typename
        ... on ThreadMessage {
          creator {
            name
            id
          }
          id
          bodyText
          insertedAt
        }
        ... on Activity {
          id
          identifier
          insertedAt
          actor {
            name
            id
          }
          toObject {
            id
            __typename
            ... on User {
              name
            }
            ... on Status {
              color
              textColor
              name
            }
            ... on Tag {
              color
              textColor
              name
            }
          }
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ... on Node {
    __isNode: __typename
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "matterId"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tenantId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "matterId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "number",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "insertedAt",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dueDate",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v10 = [
        (v3 /*: any*/)
    ], v11 = {
        "kind": "InlineFragment",
        "selections": (v10 /*: any*/),
        "type": "User",
        "abstractKey": null
    } as any, v12 = {
        "kind": "InlineFragment",
        "selections": (v10 /*: any*/),
        "type": "Group",
        "abstractKey": null
    } as any, v13 = [
        {
            "kind": "Literal",
            "name": "count",
            "value": 100
        } as any
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textColor",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    } as any, v16 = {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        } as any
    ], v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any, v20 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v21 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v22 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isNode"
    } as any, v23 = [
        (v3 /*: any*/),
        (v2 /*: any*/)
    ], v24 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": (v23 /*: any*/),
            "storageKey": null
        } as any,
        (v2 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bodyText",
            "storageKey": null
        } as any,
        (v6 /*: any*/)
    ], v25 = [
        (v15 /*: any*/),
        (v14 /*: any*/),
        (v3 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "MatterRouteQuery",
            "selections": [
                {
                    "alias": "matter",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssigneeConnection",
                                    "kind": "LinkedField",
                                    "name": "assignees",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssigneeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Assignee",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "actor",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": (v13 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "FlowList_flows"
                                },
                                {
                                    "args": (v13 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "MatterTimeline_timeline"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Status",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "HasStatus",
                                    "abstractKey": "__isHasStatus"
                                }
                            ],
                            "type": "Matter",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "matterId",
                            "variableName": "matterId"
                        },
                        (v16 /*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "MatterTimeline_threads"
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "MatterRouteQuery",
            "selections": [
                {
                    "alias": "matter",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v17 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssigneeConnection",
                                    "kind": "LinkedField",
                                    "name": "assignees",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssigneeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Assignee",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "actor",
                                                            "plural": false,
                                                            "selections": [
                                                                (v17 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": (v18 /*: any*/),
                                            "concreteType": "FlowConnection",
                                            "kind": "LinkedField",
                                            "name": "flows",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        (v19 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Flow",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v7 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "types",
                                                                            "value": [
                                                                                "de.netzwerkpartner.hotline.request"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v17 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "descriptionText",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "FileConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "files",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "FileEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "File",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v2 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "contentLength",
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v3 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "HasFiles",
                                                                                    "abstractKey": "__isHasFiles"
                                                                                }
                                                                            ],
                                                                            "type": "DeNetzwerkpartnerHotlineRequest",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v20 /*: any*/)
                                                                    ],
                                                                    "storageKey": "fields(types:[\"de.netzwerkpartner.hotline.request\"])"
                                                                },
                                                                (v17 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v21 /*: any*/)
                                            ],
                                            "storageKey": "flows(first:100)"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v18 /*: any*/),
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "FlowList_flows",
                                            "kind": "LinkedHandle",
                                            "name": "flows"
                                        },
                                        (v22 /*: any*/)
                                    ],
                                    "type": "HasFlows",
                                    "abstractKey": "__isHasFlows"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": (v18 /*: any*/),
                                            "concreteType": "TimelineItemConnection",
                                            "kind": "LinkedField",
                                            "name": "timeline",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TimelineItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v17 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": (v24 /*: any*/),
                                                                    "type": "ThreadMessage",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "identifier",
                                                                            "storageKey": null
                                                                        },
                                                                        (v6 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "User",
                                                                            "kind": "LinkedField",
                                                                            "name": "actor",
                                                                            "plural": false,
                                                                            "selections": (v23 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "toObject",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v11 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": (v25 /*: any*/),
                                                                                    "type": "Status",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": (v25 /*: any*/),
                                                                                    "type": "Tag",
                                                                                    "abstractKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Activity",
                                                                    "abstractKey": null
                                                                },
                                                                (v20 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v19 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v21 /*: any*/)
                                            ],
                                            "storageKey": "timeline(first:100)"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v18 /*: any*/),
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "MatterTimeline_timeline",
                                            "kind": "LinkedHandle",
                                            "name": "timeline"
                                        },
                                        (v22 /*: any*/)
                                    ],
                                    "type": "HasTimeline",
                                    "abstractKey": "__isHasTimeline"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Status",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "HasStatus",
                                    "abstractKey": "__isHasStatus"
                                }
                            ],
                            "type": "Matter",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "refId",
                            "variableName": "matterId"
                        },
                        (v16 /*: any*/)
                    ],
                    "concreteType": "ThreadConnection",
                    "kind": "LinkedField",
                    "name": "threads",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ThreadEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Thread",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ThreadMessageConnection",
                                            "kind": "LinkedField",
                                            "name": "messages",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ThreadMessageEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ThreadMessage",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": (v24 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "af2fe3d93f1ce8eb75284974c7b910cd",
            "id": null,
            "metadata": {},
            "name": "MatterRouteQuery",
            "operationKind": "query",
            "text": "query MatterRouteQuery(\n  $matterId: ID!\n  $tenantId: ID!\n) {\n  matter: node(id: $matterId) {\n    __typename\n    id\n    ... on Matter {\n      ...FlowList_flows_2ON54F\n      ...MatterTimeline_timeline_2ON54F\n      creator {\n        id\n        name\n      }\n      number\n      insertedAt\n      title\n      dueDate\n      state\n      ... on HasStatus {\n        __isHasStatus: __typename\n        status {\n          name\n          textColor\n          color\n          id\n        }\n      }\n      assignees {\n        edges {\n          node {\n            id\n            actor {\n              __typename\n              id\n              ... on User {\n                name\n              }\n              ... on Group {\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ...MatterTimeline_threads_1NrG5d\n}\n\nfragment FlowList_flows_2ON54F on HasFlows {\n  __isHasFlows: __typename\n  flows(first: 100) {\n    edges {\n      cursor\n      node {\n        id\n        title\n        fields(types: [\"de.netzwerkpartner.hotline.request\"]) {\n          __typename\n          ... on DeNetzwerkpartnerHotlineRequest {\n            descriptionText\n            ... on HasFiles {\n              __isHasFiles: __typename\n              files {\n                edges {\n                  node {\n                    id\n                    contentLength\n                    name\n                  }\n                }\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ... on Node {\n    __isNode: __typename\n    id\n  }\n}\n\nfragment MatterTimeline_threads_1NrG5d on RootQueryType {\n  threads(refId: $matterId, tenantId: $tenantId) {\n    edges {\n      node {\n        id\n        messages {\n          edges {\n            node {\n              creator {\n                name\n                id\n              }\n              id\n              bodyText\n              insertedAt\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MatterTimeline_timeline_2ON54F on HasTimeline {\n  __isHasTimeline: __typename\n  timeline(first: 100) {\n    edges {\n      node {\n        __typename\n        ... on ThreadMessage {\n          creator {\n            name\n            id\n          }\n          id\n          bodyText\n          insertedAt\n        }\n        ... on Activity {\n          id\n          identifier\n          insertedAt\n          actor {\n            name\n            id\n          }\n          toObject {\n            id\n            __typename\n            ... on User {\n              name\n            }\n            ... on Status {\n              color\n              textColor\n              name\n            }\n            ... on Tag {\n              color\n              textColor\n              name\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ... on Node {\n    __isNode: __typename\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'fa3ed2368e16e18914c42f51c11d6806';
export default node;
